<template>
  <div class="container">
    <div class="content">
      <div class="news-center-box">
        <div class="news-container">
          <div class="news-top-box">
            <div class="about-box">
              <div
                class="about-item"
                v-for="(item, index) in newAboutList"
                :key="index"
              >
                <div class="about-title-box">
                  <div class="about-title">{{ item.name }}</div>
                  <div class="about-subTitle">/{{ item.engName }}</div>
                </div>
                <div class="about-desc">
                  <div v-for="(info, inx) in item.infoList" :key="inx">
                    {{ info }}
                  </div>
                </div>
                <div class="about-btn" @click="handleJumpAbout(item.aboutId)">
                  查看更多
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="news-content">
            <div class="news-box">
              <div
                class="news-item"
                v-for="(item, index) in newsList"
                :key="index"
                @click="handleJumpDetail(item, 'news')"
              >
                <div class="news-date-box">
                  <div class="news-date">
                    <div class="date">{{ getDay(item.createTime) }}</div>
                    <div class="year">{{ getYear(item.createTime) }}</div>
                  </div>
                  <div class="news-line"></div>
                </div>
                <div class="news-name-excerpt">
                  <div class="news-name">{{ item.title }}</div>
                  <div class="news-excerpt">{{ item.excerpt }}</div>
                </div>
              </div>
            </div>
            <div class="news-title-box">
              <div class="news-title-red">
                <img
                  class="title-icon"
                  src="../../assets/images/home/news/news-title.png"
                  alt=""
                />
                <img
                  class="red-icon"
                  src="../../assets/images/home/news/red-icon.png"
                  alt=""
                />
                <div class="news-title">新闻中心</div>
              </div>
              <div class="news-btn" @click="handleJump('news')">更多</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="project-box">
        <div class="project-container">
          <img
            class="project-title"
            src="../../assets/images/home/project/projects-title.png"
            alt=""
          />
          <div class="line"></div>
          <div class="project-text">重点项目</div>
          <div class="project-img-box">
            <div
              class="project-item"
              v-for="(item, index) in projectImgList"
              :key="index"
              @click="handleJumpDetail(item.path)"
            >
              <img class="project-img" :src="item.cover" alt="" />
              <div class="project-name">{{ item.title }}</div>
            </div>
          </div>
          <div class="project-btn" @click="handleJump('news')">更多</div>
        </div>
      </div>
      <div class="project-box">
        <div class="project-container">
          <div class="project-text">合作伙伴</div>
          <el-image :src="require('../../assets/images/new/hezuo.png')" style="width: 55%"></el-image>
        </div>
      </div>
      <!-- <div class="tendering-box">
        <div class="tendering-container">
          <div class="tender-left-box">
            <div class="tender-title-box">
              <img
                class="title-icon"
                src="../../assets/images/home/tendering/tender-title.png"
                alt=""
              />
              <div class="title-text">招标信息</div>
            </div>
            <div class="tender-list">
              <div
                class="tender-item"
                :class="{ 'tender-active': tenderIndex === index }"
                v-for="(item, index) in tenderList"
                @mouseenter="handleHover(index)"
                @click="handleJumpDetail(item, 'tender')"
                :key="index"
              >
                <div class="tender-name">{{ item.title }}</div>
                <div class="tender-date" v-if="tenderIndex === index">
                  <div class="date">{{ getDay(item.createTime) }}</div>
                  <div class="year">{{ getYear(item.createTime) }}</div>
                </div>
                <div v-else class="index">{{ index + 1 }}</div>
              </div>
            </div>
            <div class="tender-btn" @click="handleJump('tender-info')">
              更多
            </div>
          </div>
          <div class="tender-right-box">
            <div class="tender-top-date">
              <div class="date">{{ getDay(tenderInfo.createTime) }}</div>
              <div class="year">{{ getYear(tenderInfo.createTime) }}</div>
            </div>
            <div class="tender-btm-box">
              <div class="title">{{ tenderInfo.title }}</div>
              <div class="desc">{{ tenderInfo.excerpt }}</div>
              <div class="tender-btn-box">
                <div class="btn-text" @click="handleJumpDetail(tenderInfo, 'tender')">查看详情</div>
                <img
                  @click="handleJumpDetail(tenderInfo, 'tender')"
                  class="arrow_right"
                  src="../../assets/images/arrow_right.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { homeDetail } from '@/api/urls'
import moment from 'moment'

export default {
  data () {
    return {
      // 视频状态暂停播放
      videoPlaying: false,
      // 新闻中心相关
      newAboutList: [
        
        {
          name: '公司简介',
          engName: 'INTRODUCTION',
          aboutId: 'sixth',
          infoList: [
            '从事商务服务业',
            '乡村振兴、现代农业和大健康产业未来模式的领跑者',
            '设施农业、数字经济、城乡融合发展的践行者'
          ]
        },
        {
          name: '股东背景',
          engName: 'SHAREHOLDER',
          aboutId: 'first',
          infoList: [
            '新农创成立于2012年，由首农、首创两大国有企业联合发起，专注于打造乡村振兴样板工程。',
            '首农集团',
            '首创集团'
          ]
        },
        {
          name: '优势',
          engName: 'ADVANTAGE',
          aboutId: 'fourth',
          infoList: [
            '优质农产品开发',
            'EPA第三代农业种植技术',
            '活性竹粉',
            '生猪全产业链产融平台',
            '预制菜',
            '建筑新材料应用'
          ]
        }
      ],
      // 新闻中心列表
      newsList: [],
      // 重点项目相关
      projectImgList: [
        { title: 'EPA农业种植技术', cover: require('../../assets/images/new/zhongzhi.png'), path: 'epa-detail' },
        { title: '活性竹粉', cover: require('../../assets/images/new/zhufen.png'), path: 'huoxing-detail' },
        { title: '预制菜', cover: require('@/assets/images/new/yuzhi.png'), path: 'yuzhi-detail' },
        { title: '装配式建筑', cover: require('../../assets/images/new/jianzhu/img4.png'), path: 'jianzhu-detail' },
        { title: '设施农业和海洋牧场', cover: require('../../assets/images/new/sheshi/img8.png'), path: 'sheshi-detail' }
      ],
      // 招标相关
      tenderList: [],
      tenderInfo: {},
      tenderIndex: 0,
      info: {}
    }
  },
  async mounted () {
    // this.getHomeInfo()
  },
  methods: {
    getHomeInfo () {
      homeDetail().then((res) => {
        console.log(res)
        this.info = res.data
        this.projectImgList = this.info.projectList
        this.newsList = this.info.newsList
        this.newsList = this.info.newsList
        this.tenderList = this.info.bidList.splice(0, 3)
        this.tenderInfo = this.tenderList[this.tenderIndex]
        console.log(this.tenderList)
      })
    },
    // 鼠标悬停切换
    handleHover (index) {
      this.tenderIndex = index
      this.tenderInfo = this.tenderList[index]
    },
    // 获取日期
    getDay (date) {
      return moment(date).format('MM-DD')
    },
    // 获取年
    getYear (date) {
      return moment(date).year()
    },
    // 跳转页面
    handleJump (name) {
      this.$router.push({
        path: name
      })
    },
    // 跳转详情页
    handleJumpDetail (path) {
      this.$router.push({
        path: path
      })
      // if (type === 'news') {
      //   this.$router.push({
      //     path: 'news-detail',
      //     query: {
      //       id: item.id
      //     }
      //   })
      // } else if (type === 'project') {
      //   this.$router.push({
      //     path: 'project-detail',
      //     query: {
      //       id: item.id
      //     }
      //   })
      // } else if (type === 'tender') {
      //   this.$router.push({
      //     path: 'tender-detail',
      //     query: {
      //       id: item.id
      //     }
      //   })
      // }
    },
    // 跳转关于我们
    handleJumpAbout (aboutId) {
      this.$router.push({
        path: 'about',
        query: {
          aboutId
        }
      })
    },
    // 控制视频
    handleVideo () {
      const video = this.$refs.homeVideo
      if (video.paused) {
        video.play()
        this.videoPlaying = true
      } else {
        video.pause()
        this.videoPlaying = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding-bottom: 36px;
  // min-width: 1280px;
  width: 100%;
  // padding-top: 42px;
  .content {
    // ::v-deep .el-carousel__button {
    //   width: 10px;
    //   height: 10px;
    //   border: none;
    //   border-radius: 50%;
    //   opacity: 1;
    //   background-color: #fff;
    // }
    // ::v-deep .is-active .el-carousel__button {
    //   background: #4b9ced;
    // }
    .news-center-box {
      width: 100%;
      min-height: 200px;
      background: url('../../assets/images/home/news/news-bg.png') 0 0 no-repeat;
      background-size: 100%;
      .news-container {
        width: 900px;
        min-width: 900px;
        margin: 0 auto;
        padding: 60px;
        .news-top-box {
          display: flex;
          align-items: end;
          .video-box {
            position: relative;
            width: 334px;
            height: 180px;
            margin-right: 25px;
            .video {
              width: 100%;
              height: 100%;
            }
            .video-btn {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              display: flex;
              align-items: center;
              justify-content: center;
              width: 170px;
              height: 42px;
              background: url('../../assets/images/home/video-bg.png') 0 0
                no-repeat;
              background-size: 100%;
              cursor: pointer;
              .play-text {
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 19px;
                color: #202020;
                margin-right: 14px;
              }
              .play-icon {
                width: 19px;
                height: 19px;
              }
            }
          }
          .about-box {
            display: flex;
            // align-items: center;
            width: 100%;
            /* height: 208px; */
            /* padding: 20px 26px 0 26px; */
            /* background: rgba(226, 230, 233, 0.6); */
            .about-item {
              flex: 1;
              margin-right: 20px;
              background: rgba(226, 230, 233, 0.6);
              padding: 20px;
              .about-title-box {
                display: flex;
                align-items: end;
                margin-bottom: 18px;
                .about-title {
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  font-size: 20px;
                  color: #004e8f;
                  margin-right: 4px;
                }
                .about-subTitle {
                  font-family: Arial;
                  font-weight: 400;
                  font-size: 14px;
                  color: #4f5561;
                }
              }
              .about-desc {
                /* width: 162px; */
                height: 99px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 13px;
                color: #858789;
                margin-bottom: 22px;
              }
              .about-btn {
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 12px;
                color: #3d7fce;
                zoom: 0.9;
                text-decoration-line: underline;
                cursor: pointer;
                // padding-bottom: 5px;
              }
            }
          }
        }
        .news-content {
          display: flex;
          .news-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .news-item {
              display: flex;
              // justify-content: center;
              align-items: center;
              width: 340px;
              height: 136px;
              background: #ffffff;
              box-shadow: 0px 0px 4px 0px rgba(220, 220, 220, 0.64);
              border-radius: 4px;
              margin-bottom: 25px;
              padding: 0px 10px 0 10px;
              &:nth-child(odd) {
                margin-right: 40px;
              }
              .news-date-box {
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                margin-right: 42px;
                .news-date {
                  margin-bottom: 55px;
                  .date {
                    font-family: Arial;
                    font-weight: bold;
                    font-size: 14px;
                    color: #202020;
                    // margin-bottom: 6px;
                  }
                  .year {
                    font-family: Arial;
                    font-weight: 900;
                    font-size: 12px;
                    zoom: 0.8;
                    color: #c1c1c1;
                  }
                }
                .news-line {
                  width: 38px;
                  height: 1px;
                  background: #c1c1c1;
                }
              }
              .news-name-excerpt {
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                .news-name {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 14px;
                  color: #303133;
                  margin-bottom: 15px;
                }
                .news-excerpt {
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 12px;
                  zoom: 0.9;
                  color: #777777;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 4; /*省略几行写几*/
                  -webkit-box-orient: vertical;
                  line-height: 17px;
                }
              }
            }
          }
          .news-title-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .news-title-red {
              display: flex;
              flex-direction: column;
              .title-icon {
                width: 100px;
                height: 40px;
                margin-bottom: 18px;
              }
              .red-icon {
                width: 38px;
                height: 4px;
                margin-bottom: 20px;
              }
              .news-title {
                font-family: Source Han Sans CN;
                font-weight: 800;
                font-size: 20px;
                color: #004e8f;
              }
            }
            .news-btn {
              width: 84px;
              height: 27px;
              text-align: center;
              zoom: 0.9;
              line-height: 27px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 12px;
              color: #ffffff;
              background: #004e8f;
            }
          }
        }
      }
    }
    .project-box {
      width: 100%;
      min-height: 550px;
      padding-top: 45px;
      background: #fff;
      .project-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        .project-title {
          width: 430px;
          height: 28px;
          margin-bottom: 2px;
        }
        .line {
          width: 38px;
          height: 4px;
          background: #e50012;
          border-radius: 2px;
          margin-bottom: 12px;
        }
        .project-text {
          font-family: Source Han Sans CN;
          font-weight: 800;
          font-size: 20px;
          color: #004e8f;
          margin-bottom: 28px;
        }
        .project-img-box {
          display: flex;
          align-items: end;
          justify-content: space-between;
          margin-bottom: 56px;
          .project-item {
            width: 155px;
            margin: 0 20px 0 0;
            text-align: center;
            cursor: pointer;
            .project-img {
              width: 100%;
              height: 250px;
              margin-bottom: 16px;
              object-fit: cover;
              border-radius: 10px;
            }
            .project-name {
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 14px;
              color: #303133;
            }
          }
        }
        .project-btn {
          width: 84px;
          height: 28px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 12px;
          zoom: 0.9;
          color: #ffffff;
          text-align: center;
          line-height: 28px;
          background: #004e8f;
          cursor: pointer;
        }
      }
    }
    .tendering-box {
      width: 100%;
      min-height: 504px;
      background: url('../../assets/images/home/tendering/bg.png') 0 0 no-repeat;
      background-size: 100% 100%;
      .tendering-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 24px;
        // flex-direction: column;
        .tender-left-box {
          margin-right: 37px;
          .tender-title-box {
            margin-bottom: 54px;
            .title-icon {
              width: 172px;
              height: 40px;
              margin-bottom: 15px;
            }
            .title-text {
              font-family: Source Han Sans CN;
              font-weight: 800;
              font-size: 20px;
              color: #ffffff;
            }
          }
          .tender-list {
            .tender-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              min-width: 283px;
              padding-bottom: 30px;
              margin-bottom: 36px;
              &.tender-active {
                border-bottom: 2px solid #ffffff;
              }
              .tender-name {
                width: 171px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .tender-date {
                .date {
                  font-family: Bahnschrift;
                  font-weight: normal;
                  font-size: 28px;
                  color: #ffffff;
                  margin-bottom: 5px;
                }
                .year {
                  width: 32px;
                  background: #000000;
                  border-radius: 3px;
                  text-align: center;
                  line-height: 13px;
                  font-family: Bahnschrift;
                  font-weight: 400;
                  font-size: 12px;
                  color: #ffffff;
                }
              }
              .index {
                font-family: Arial;
                font-weight: 400;
                font-size: 38px;
                color: #fffcef;
              }
            }
          }
          .tender-btn {
            width: 84px;
            height: 27px;
            border: 1px solid #ffffff;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 12px;
            color: #ffffff;
            line-height: 27px;
            text-align: center;
            zoom: 0.9;
            margin-bottom: 27px;
            cursor: pointer;
          }
        }
        .tender-right-box {
          position: relative;
          width: 554px;
          min-height: 342px;
          background: #ffffff;
          box-shadow: 0px 0px 7px 0px rgba(151, 188, 231, 0.31);
          padding: 30px 42px;
          .tender-top-date {
            border-bottom: 1px solid #cfe3fa;
            padding-bottom: 20px;
            margin-bottom: 20px;
            .date {
              font-family: Bahnschrift;
              font-weight: normal;
              font-size: 37px;
              color: #0b40b1;
              margin-bottom: 5px;
            }
            .year {
              width: 43px;
              height: 17px;
              background: #000000;
              border-radius: 3px;
              font-family: Bahnschrift;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 17px;
              text-align: center;
            }
          }
          .tender-btm-box {
            .title {
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 25px;
              color: #303133;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 30px;
            }
            .desc {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              zoom: 0.9;
              color: #777777;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4; /*省略几行写几*/
              -webkit-box-orient: vertical;
              line-height: 19px;
            }
            .tender-btn-box {
              // position: absolute;
              // left: ;
              // bottom: 34px;
              width: 100%;
              margin-top: 50px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .btn-text {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 12px;
                zoom: .9;
                color: #3E7FCE;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
